var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNextArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 14,
    viewBox: "0 0 17 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.32541 0.566037C9.65749 0.24738 10.185 0.258261 10.5037 0.59034L16.1012 6.42367C16.4106 6.74611 16.4106 7.2552 16.1012 7.57763L10.5037 13.411C10.185 13.743 9.65749 13.7539 9.32541 13.4353C8.99333 13.1166 8.98245 12.5891 9.30111 12.257L13.52 7.86043H1.33333C0.873096 7.86043 0.5 7.48734 0.5 7.0271C0.5 6.56686 0.873096 6.19377 1.33333 6.19377H13.5707L9.30111 1.7443C8.98245 1.41222 8.99333 0.884694 9.32541 0.566037Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNextArrow);
export default __webpack_public_path__ + "static/media/NextArrow.3f7445406f19b84d81b92fbb0d047607.svg";
export { ForwardRef as ReactComponent };